import {User} from '../graphql/auth';

export default (user: User): number => {
    const level = user.roles!.map(role => role.level ).sort().shift();
    return level !== undefined? level : 999;
}